"use client";

import * as React from "react";
import { ThemeProvider as NextThemesProvider } from "next-themes";

// next-themes (unmaintained since March 2025) injects a raw <script> tag to
// set the theme class before hydration and avoid a flash of the wrong
// theme -- it genuinely works, since that script is really part of the
// server-rendered HTML the browser parses and executes. React 19 added a
// blanket dev-only warning for any <script> host element it processes
// during a client render pass, though, and can't distinguish "this was
// already executed by the browser during hydration" from "this is a
// client-only script that won't run" -- so this specific, well-documented
// false positive fires anyway. Confirmed via next-themes issues #385/#387
// and shadcn-ui issue #10104 -- the standard workaround until the library
// either gets fixed or is replaced is to filter just this one message.
if (typeof window !== "undefined" && process.env.NODE_ENV === "development") {
  const originalConsoleError = console.error;
  console.error = (...args: unknown[]) => {
    if (typeof args[0] === "string" && args[0].includes("Encountered a script tag")) return;
    originalConsoleError.apply(console, args);
  };
}

function ThemeProvider({ children }: { children: React.ReactNode }) {
  return (
    <NextThemesProvider attribute="class" defaultTheme="system" enableSystem>
      {children}
    </NextThemesProvider>
  );
}

export { ThemeProvider };
